/** @format */

import React, { useState } from 'react';
import '../css/Awards.css';

import { IoAdd, IoRemove } from 'react-icons/io5';

const Awards = () => {
  const [open, setOpen] = useState(0);

  return (
    <section className='Awards'>
      <div className='awards-container container padding'>
        <div className='awards-intro'></div>
        <div className='awards-content'>
          <h2>
            No te limites aprende
            <br />
            3D desde cero
          </h2>
          <div className='awards-items'>
            <div className='awards-item'>
              <div
                className={`awards-item-head ${
                  open === 1 ? 'open' : null
                }`}
                onClick={() => {
                  setOpen(1);
                }}>
                <h3 style={open === 1 ? { color: '#000' } : null}>
                  01. Perfil del estudiante
                </h3>
                <div className='awards-item-icon'>
                  {open === 1 ? <IoRemove /> : <IoAdd />}
                </div>
              </div>
              <div
                className={`awards-item-body ${
                  open === 1 ? 'open' : null
                }`}>
                <ul>
                  <li>Personas de 14 años en adelante.</li>
                  <li>
                    Sentir afinidad por el diseño 3D o las artes
                    gráficas en general.
                  </li>
                  <li>No es necesario tener conocimientos en 3D.</li>
                </ul>
              </div>
            </div>
            <div className='awards-item'>
              <div
                className={`awards-item-head ${
                  open === 2 ? 'open' : null
                }`}
                onClick={() => {
                  setOpen(2);
                }}>
                <h3 style={open === 2 ? { color: '#000' } : null}>
                  02. Requisitos técnicos
                </h3>
                <div className='awards-item-icon'>
                  {open === 2 ? <IoRemove /> : <IoAdd />}
                </div>
              </div>
              <div
                className={`awards-item-body ${
                  open === 2 ? 'open' : null
                }`}>
                Computador de gama media Core i5 (o similares) de 7ma
                generación con 12 de Ram. Tarjeta de vídeo gt 1030 o
                gtx 1050. Mouse o tabla digitalizadora.
              </div>
            </div>
            <div className='awards-item'>
              <div
                className={`awards-item-head ${
                  open === 3 ? 'open' : null
                }`}
                onClick={() => {
                  setOpen(3);
                }}>
                <h3 style={open === 3 ? { color: '#000' } : null}>
                  03. Clases online
                </h3>
                <div className='awards-item-icon'>
                  {open === 3 ? <IoRemove /> : <IoAdd />}
                </div>
              </div>
              <div
                className={`awards-item-body ${
                  open === 3 ? 'open' : null
                }`}>
                <ul>
                  <li>Clases en vídeo.</li>
                  <li>Imágenes y material de referencia.</li>
                  <li>Grupo en Discord General.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Awards;
